import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  getfactoriesForDropDown,
  getAllEntitiesByGroupIDTypeID,
  GetRegionalOffice,
  getBudgetCodeDetails,
  GetSKUNamesByID,
  SaveMappingDetails,
  GetDetailsBySKUCategoryID,
  getRegoinsForDropdown,
  getWarehouseForDropDown,
  GetStoreWarehouseForDropDown,
  GetWarehouseForDropDownByEntityType,
  GetExestingMappingDetail,
  GetSKUCategoryNamesByID,
  GetSKUNamesByCategoryID,
  GetMappingDetails,
  GetSKUCategoryNamesByBudjetID,
  DeleteMappingDetails,
  getPurchaseCategoriesForDropdown,
  getPurchaseTypesForDropdown,
  getEntityTypesForDropdown,
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getPurchaseCategoriesForDropdown() {
  let response = await CommonGet('/api/PurchaseCategory/GetPurchaseCategoriesForDropdown', null);
  let purchaseCategoryArray = []
  for (let item of Object.entries(response.data)) {
    purchaseCategoryArray[item[1]["purchaseCategoryID"]] = item[1]["purchaseCategoryName"]
  }
  return purchaseCategoryArray;
}

async function getPurchaseTypesForDropdown() {
    let response = await CommonGet('/api/PurchaseType/GetAllPurchaseTypes', null);
    let purchaseTypesArray = []
    for (let item of Object.entries(response.data)) {
        purchaseTypesArray[item[1]["purchaseTypeID"]] = item[1]["purchaseTypeName"]
    }
    return purchaseTypesArray;
}

async function getEntityTypesForDropdown() {
    let response = await CommonGet('/api/Factory/GetAllEntityTypes', null);
    let purchaseTypesArray = []
    for (let item of Object.entries(response.data)) {
        purchaseTypesArray[item[1]["entityTypeID"]] = item[1]["entityTypeName"]
    }
    return purchaseTypesArray;
}

async function getRegoinsForDropdown(groupID) {
  var regoinArray = [];

  const response = await CommonGet('/api/WarehouseSKUMapping/GetGetRegionsByGroupID', "groupID=" + parseInt(groupID))
  for (let item of Object.entries(response.data)) {
    regoinArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return regoinArray;
}

async function GetRegionalOffice() {
  var regoinArray = [];

  const response = await CommonGet('/api/Factory/GetRegionalOffice', null)
  for (let item of Object.entries(response.data)) {
    regoinArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return regoinArray;
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getAllEntitiesByGroupIDTypeID(groupID,entityTypeID) {
  let response = await CommonGet('/api/Factory/GetAllEntitiesByGroupIDTypeID', 'groupID=' + parseInt(groupID) + '&entityTypeID=' + parseInt(entityTypeID));
  let entityArray = []
  for (let item of Object.entries(response.data)) {
    entityArray[item[1]["entityID"]] = item[1]["entityName"]
  }
  return entityArray;
}

async function getBudgetCodeDetails() {
  let response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes', null);
  let budgetCodeArray = [];
  for (let item of Object.entries(response.data)) {
    budgetCodeArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"];
  }
  budgetCodeArray[0] = '--Select Account Code--';
  
  return budgetCodeArray;
};

async function getWarehouseForDropDown(factoryID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetWarehouseDetails', "factoryID=" + parseInt(factoryID));
  let warehouseArray = [];
  for (let item of Object.entries(response.data)) {
    warehouseArray[item[1]["warehouseID"]] = item[1]["warehouseName"];
  }
  return warehouseArray;
};

async function GetStoreWarehouseForDropDown(groupID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetStoreWarehouseForDropDown',  "groupID=" + parseInt(groupID));
  let storeWarehouseArray = [];
  for (let item of Object.entries(response.data)) {
    storeWarehouseArray[item[1]["warehouseID"]] = item[1]["warehouseName"];
  }
  return storeWarehouseArray;
};

async function GetWarehouseForDropDownByEntityType(entityTypeID, entityID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetWarehouseForDropDownByEntityType', "entityTypeID=" + parseInt(entityTypeID) + '&entityID=' + parseInt(entityID));
  let warehouseArray = [];
  for (let item of Object.entries(response.data)) {
    warehouseArray[item[1]["warehouseID"]] = item[1]["warehouseName"];
  }
  return warehouseArray;
};

async function GetSKUNamesByID(budgetCodeID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetSKUNamesByID', 'budgetCodeID=' + budgetCodeID);
  let skuArray = [];
  for (let item of Object.entries(response.data)) {
    skuArray[item[1]["skuMasterID"]] = item[1]["skuMasterName"];
  }
  return skuArray;
}

async function GetSKUNamesByCategoryID(skuCategoryID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetSKUNamesByCategoryID', 'skuCategoryID=' + skuCategoryID);
  let skuArray = [];
  for (let item of Object.entries(response.data)) {
    skuArray[item[1]["skuMasterID"]] = item[1]["skuMasterName"];
  }
  return skuArray;
}

async function GetSKUCategoryNamesByID(estateID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetSKUCategoryNamesByID', 'estateID=' + estateID);
  let categoryArray = [];
  for (let item of Object.entries(response.data)) {
    categoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"];
  }
  return categoryArray;
}

// async function GetSKUCategoryNamesByBudjetID(budgetCodeID,groupID) {
//   let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDBudgetCodeID', 'budgetCodeID=' + budgetCodeID +'&groupID=' + groupID);
//   let categoryArray = [];
//   for (let item of Object.entries(response.data)) {
//     categoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"];
//   }
//   return categoryArray;
// }

async function SaveMappingDetails(model) {
  const modifiedModel = model.map(item => ({
    groupID: item.groupID,
    entityID: item.factoryID,
    entityTypeID : item.entityTypeID,
    parentEntityID : item.regionID,
    warehouseID: item.warehouseID,
    defaultWarehouseID: item.defaultWarehouseID,
    purchaseCategoryID: item.purchaseCategoryID,
    purchaseTypeID: item.purchaseTypeID,
    budgetCodeID: item.budgetCodeID,
    skuCategoryID: item.skuCategoryID,
    skuMasterID: item.skuMasterID,
    createdBy:item.createdBy,
    createdDate:item.createdDate
  }));
  const response = await CommonPost('/api/WarehouseSKUMapping/SaveMappingDetails', null, modifiedModel);
  return response;
};

async function GetExestingMappingDetail(model) {
  let response = await CommonPost('/api/WarehouseSKUMapping/GetExestingMappingDetail', null, model);
  return response;
};

async function GetMappingDetails(model) {
  const response = await CommonPost('/api/WarehouseSKUMapping/GetMappingDetails', null, model);
  return response;
};

async function DeleteMappingDetails(model) {
  const response = await CommonPost('/api/WarehouseSKUMapping/DeleteMappingDetails', null, model)
  return response;
}

async function GetDetailsBySKUCategoryID(skuCategoryID) {
  let response = await CommonPost('/api/SKUCategory/GetDetailsBySKUCategoryID', "SKUCategoryID=" + parseInt(skuCategoryID))
  return response.data;
}

async function GetSKUCategoryNamesByBudjetID(budgetCodeID, groupID, factoryID) {
    let response = await CommonGet(
        '/api/SKUCategory/GetSKUCategoryNamesByEstateIDBudgetCodeIDANDFactoryID', 
        'budgetCodeID=' + budgetCodeID + 
        '&groupID=' + groupID + 
        '&factoryID=' + factoryID 
    );
    let categoryArray = [];
    for (let item of Object.entries(response.data)) {
        categoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"];
    }
    return categoryArray;
}

